<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getStockOpnames"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="stockOpnamePlans" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Stock Opname Plan" id="filter-" size="sm" :model.sync="filter.stockOpnamePlanId" @input="getStockOpnamePlans" @focus="getStockOpnamePlans" />
					<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Area" id="filter-" size="sm" :model.sync="filter.areaStoId" @input="getAreas" @focus="getAreas" />
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Subcontract Vendor" id="filter-" size="sm" :model.sync="filter.vendorSubconId" @input="getVendors" @focus="getVendors" />
					<app-input-textbox id="fieldset-id-card" label-cols-sm="4" label-cols-lg="3" label="ID Card" label-for="filter-id-card" size="sm" :model.sync="filter.idCard" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-total-case-area" label-cols-sm="4" label-cols-lg="3" label="Total Case" label-for="filter-total-case-area" size="sm" :model.sync="filter.totalCaseArea" />
					<app-input-textbox id="fieldset-total-case-actual" label-cols-sm="4" label-cols-lg="3" label="Total Case Actual" label-for="filter-total-case-actual" size="sm" :model.sync="filter.totalCaseActual" />
					<app-input-combobox-autocomplete :options="stockOpnameStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Stock Opname Status" id="filter-" size="sm" :model.sync="filter.stockOpnameStatusId" @input="getStockOpnameStatuss" @focus="getStockOpnameStatuss" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getStockOpnames"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Stock Opname</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="false" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/stockopname/StockOpname.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Start Scan</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Start Scan</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="false" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					
					<b-overlay v-if="isShowDeleteButton"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-stockopname" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="stockOpnames" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="stockOpnames.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<div class="d-flex justify-content-center ml-2" v-if="true">
							<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
						</div>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Stock Opname Plan" class="table-filter">
					<v-select append-to-body label="name" :options="stockOpnamePlans" :value="filter.stockOpnamePlanId" :reduce="item => item.id" v-model="filter.stockOpnamePlanId" :filterable="true" @input="getStockOpnamesWithoutLoading" @search="getStockOpnamePlans"></v-select>
				</b-th>
				<b-th stacked-heading="Area" class="table-filter">
					<v-select append-to-body label="code" :options="areas" :value="filter.areaStoId" :reduce="item => item.id" v-model="filter.areaStoId" :filterable="true" @input="getStockOpnamesWithoutLoading" @search="getAreas"></v-select>
				</b-th>
				<b-th stacked-heading="Subcontract Vendor" class="table-filter">
					<v-select append-to-body label="code" :options="vendors" :value="filter.vendorSubconId" :reduce="item => item.id" v-model="filter.vendorSubconId" :filterable="true" @input="getStockOpnamesWithoutLoading" @search="getVendors"></v-select>
				</b-th>
				<b-th stacked-heading="ID Card" class="table-filter">
					<b-form-input id="input-id-card-table" @input="getStockOpnamesWithoutLoading" v-model="filter.idCard" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Total Case" class="table-filter">
					<b-form-input id="input-total-case-area-table" @input="getStockOpnamesWithoutLoading" v-model="filter.totalCaseArea" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Total Case Actual" class="table-filter">
					<b-form-input id="input-total-case-actual-table" @input="getStockOpnamesWithoutLoading" v-model="filter.totalCaseActual" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Stock Opname Status" class="table-filter">
					<v-select append-to-body label="name" :options="stockOpnameStatuss" :value="filter.stockOpnameStatusId" :reduce="item => item.id" v-model="filter.stockOpnameStatusId" :filterable="true" @input="getStockOpnamesWithoutLoading" @search="getStockOpnameStatuss"></v-select>
				</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(stockopnameplan)="row">

                <a @click="() => ( $router.push({ name: 'stockopnamedetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.stockOpnamePlan.name != null && row.item.stockOpnamePlan.name != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.stockOpnamePlan.name.slice(0, 30) + (row.item.stockOpnamePlan.name.length > 30 ? "..." : "" ) : row.item.stockOpnamePlan.name : "" }}
						</a>
            
					</template>

			<template v-slot:cell(areaSto)="row">
				{{ row.item.areaSto != null ? row.item.areaSto.code : "" }}
			</template>
			<template v-slot:cell(vendorSubcon)="row">
				{{ row.item.vendorSubcon != null ? row.item.vendorSubcon.code : "" }}
			</template>
			<template v-slot:cell(stockOpnameStatus)="row">
				{{ row.item.stockOpnameStatus != null ? row.item.stockOpnameStatus.name : "" }}
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="isStoActive(row.item)">
							<!-- <b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox> -->
							 <b-button variant="primary" size="sm" @click="reSyncStoDetail(row.item.id)"><b-icon icon="arrow-repeat"></b-icon></b-button>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.vendorSubconId" label="Subcontract Vendor" :selected="row.item.vendorSubcon != null ? row.item.vendorSubcon.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-id-card" label-cols-lg="12"  label="ID Card" label-for="input-id-card" size="sm" :model.sync="row.item.idCard"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-case-area" label-cols-lg="12"  label="Total Case" label-for="input-total-case-area" size="sm" :model.sync="row.item.totalCaseArea"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-case-actual" label-cols-lg="12"  label="Total Case Actual" label-for="input-total-case-actual" size="sm" :model.sync="row.item.totalCaseActual"   :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.stockOpnameStatusId" label="Stock Opname Status" :selected="row.item.stockOpnameStatus != null ? row.item.stockOpnameStatus.name : ''" :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(stockOpnamesPaging != null ? stockOpnamesPaging.dataCount : 0)"
									:per-page="(stockOpnamesPaging != null ? stockOpnamesPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
	
    

    ::v-deep #table-list-stockopname.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-stockopname.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-stockopname.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import StockOpname from '@/models/StockOpname/StockOpname';
import StockOpnameList from '@/models/StockOpname/StockOpnameList';
import StockOpnameFilter from '@/filters/StockOpname/StockOpnameFilter';
import RoleDetail from '@/models/Core/RoleDetail';
import toast from '@/mixins/toastMixin';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import StockOpnamePlanFilter from '@/filters/StockOpnamePlan/StockOpnamePlanFilter';
import StockOpnamePlan from '@/models/StockOpnamePlan/StockOpnamePlan';
import AreaFilter from '@/filters/Area/AreaFilter';
import Area from '@/models/Area/Area';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import Vendor from '@/models/Vendor/Vendor';
import AppInputTextbox from '@/components/AppInputTextbox';
import StockOpnameStatusFilter from '@/filters/StockOpnameStatus/StockOpnameStatusFilter';
import StockOpnameStatus from '@/models/StockOpnameStatus/StockOpnameStatus';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		StockOpname, 
		StockOpnameList, 
		StockOpnameFilter, 
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	mixins : [toast],
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"stockOpnamePlan": {}, "class" : "th-stock-opname-plan first-child", "label" : "Stock Opname Plan", key: 'stockOpnamePlan', sortable: true}, 
				{"areaSto": {}, "class" : "th-area-sto", "label" : "Area", key: 'areaSto', sortable: true}, 
				{"vendorSubcon": {}, "class" : "th-vendor-subcon last-child", "label" : "Subcontract Vendor", key: 'vendorSubcon', sortable: true}, 
				{"idCard": {}, "class" : "th-id-card d-stack-none", "label" : "ID Card", key: 'idCard', sortable: true}, 
				{"totalCaseArea": {}, "class" : "th-total-case-area d-stack-none", "label" : "Total Case", key: 'totalCaseArea', sortable: true}, 
				{"totalCaseActual": {}, "class" : "th-total-case-actual d-stack-none", "label" : "Total Case Actual", key: 'totalCaseActual', sortable: true}, 
				{"stockOpnameStatus": {}, "class" : "th-stock-opname-status d-stack-none", "label" : "Stock Opname Status", key: 'stockOpnameStatus', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			stockOpnames: [],
			stockOpnamesPaging: {},
			stockOpnamePlans : [],
			areas : [],
			vendors : [],
			stockOpnameStatuss : [],
			stockOpnameDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
			
		}
	},	methods : {
		isStoActive(obj) {
			if(!obj) return false;
			if(!obj.stockOpnamePlan || !obj.stockOpnamePlan.stockOpnameStatus) return false;

			let stoStatus = obj.stockOpnamePlan.stockOpnameStatus.code;
			if(stoStatus != 'IN_PROGRESS') return false;

			return true;
		},
		reSyncStoDetail : async function(id) {
			try {
				const response = await this.$http.post(`stockopname/resyncstodetail/${id}`);
				if(response && response.data) {
					this.toast({message: 'Berhasil Sync Data STO', title:'Success', variant : 'success',autoHideDelay:3000});
				}
			} catch(error) {
				this.toast({message: 'Gagal Sync Data STO', title:'Error', variant : 'danger', autoHideDelay:99999});
			}
		},
		getStockOpnames : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			StockOpname.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.stockOpnames = result.data
					this.stockOpnamesPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getStockOpnamesWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			StockOpname.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.stockOpnames = result.data
					this.stockOpnamesPaging = result
				}
			})
			.catch(error => {});
		},
		getStockOpnamePlans : async function(input) {
			let filter = new StockOpnamePlanFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await StockOpnamePlan.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnamePlans = result.data
				}
			})
			.catch(error => {});
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		getStockOpnameStatuss : async function(input) {
			let filter = new StockOpnameStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await StockOpnameStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnameStatuss = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new StockOpnameFilter();
			this.getStockOpnames();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getStockOpnames();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				StockOpname.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			StockOpname.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			StockOpname.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			StockOpname.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'stockopnameedit';
						if(this.isScannerMode) {
							createRoute = 'stockopnamescan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			StockOpname.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'stockopnameedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			StockOpname.deleteData(this, id).then(result => {
				if (result)
				{
					this.getStockOpnames();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				StockOpname.deleteMultipleData(this).then(result => {
					this.getStockOpnames();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableStockOpnameParent = document.getElementById('table-list-stockopname').parentNode;
			tableStockOpnameParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableStockOpnameParent.scrollWidth - tableStockOpnameParent.offsetWidth) == Math.ceil(tableStockOpnameParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableStockOpnameParent = document.getElementById('table-list-stockopname').parentNode;
			tableStockOpnameParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableStockOpnameParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new StockOpnameFilter();
		this.getStockOpnamePlans();
		this.getAreas();
		this.getVendors();
		this.getStockOpnameStatuss();
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Stock Opname"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getStockOpnames();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getStockOpnames();
			}
		},
		sortDesc: {
			handler: function() {
				this.getStockOpnames();
			}
		},
		currentPage: {
			handler: function() {
				this.getStockOpnames();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getStockOpnames();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				StockOpname.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "stockopnameindex") {
					this.getStockOpnamesWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "stock_opname").first();
		},
		isShowDeleteButton : function() {
			return false;
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
